// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Icon_wrapper__NN2Lu","icon":"Icon_icon__PNcX6","inner":"Icon_inner__ZTFbt"};